import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AuthIntendedDestinationState = {
  intendedPath: string | null;
};

const initialState: AuthIntendedDestinationState = {
  intendedPath: null,
};

export const authIntendedDestinationSlice = createSlice({
  name: 'authIntendedDestination',
  initialState,
  reducers: {
    setIntendedPath(state, action: PayloadAction<string>) {
      state.intendedPath = action.payload;
    },
    clearIntendedPath(state) {
      state.intendedPath = null;
    },
  },
});

export const { setIntendedPath, clearIntendedPath } =
  authIntendedDestinationSlice.actions;

export const selectIntendedPath = (state: {
  authIntendedDestination: AuthIntendedDestinationState;
}) => state.authIntendedDestination.intendedPath;
